<template>
  <div class="m-auto">
    <div>
      <component
        v-bind:is="steps[currentStep].component"
        :payment-information="paymentInformation"
        @proceed-to-process-booking="proceedToProcessBooking"
        @payment-success="(bookings) => $emit('payment-success', bookings)"
        @close="$emit('close')"
        @back="previous"
      />
    </div>
  </div>
</template>

<script>
import PaymentMethod from "./payment-wizard-steps/payment-method.vue";
import PaymentBreakdown from "./payment-wizard-steps/payment-breakdown.vue";
import { mapGetters } from "vuex";

export default {
  name: "PaymentWizard",
  components: {
    PaymentMethod,
    PaymentBreakdown,
  },
  props: {
    paymentInformation: Object,
  },
  data() {
    return {
      currentStep: 0,
      submitted: false,
      paymentSteps: [
        {
          component: PaymentMethod,
          label: "payment-method",
        },
        {
          component: PaymentBreakdown,
          label: "payment-breakdown",
        },
      ],
      freeRouteSteps: [
        {
          component: PaymentBreakdown,
          label: "payment-breakdown",
        },
      ],
    };
  },
  created() {
    if (this.paymentInformation.pricePerPassenger === 0) {
      this.paymentInformation.paymentOption = "wallet";
      this.paymentInformation.walletSource = "main_balance";
      this.$store.dispatch(
        "app/changeWalletSource",
        this.paymentInformation.walletSource
      );
    }
  },
  mounted() {},
  computed: {
    ...mapGetters("app"),
    steps() {
      if (this.paymentInformation.pricePerPassenger === 0) {
        return this.freeRouteSteps;
      } else {
        return this.paymentSteps;
      }
    },
  },
  methods: {
    next() {
      this.currentStep += 1;
    },
    previous() {
      this.currentStep -= 1;
    },

    proceedToProcessBooking(paymentInformation) {
      this.paymentInformation = paymentInformation;
      this.next();
    },
  },
};
</script>